import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRouteFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#737373",
			d: "M6 14.875a4.125 4.125 0 1 1 0 8.25 4.125 4.125 0 0 1 0-8.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#737373",
			d: "M12 3.875a1.125 1.125 0 0 1 0 2.25H8.5a2.375 2.375 0 0 0 0 4.75h7a4.625 4.625 0 0 1 0 9.25H12a1.125 1.125 0 0 1 0-2.25h3.5a2.375 2.375 0 1 0 0-4.75h-7a4.625 4.625 0 0 1 0-9.25z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#737373",
			d: "M18 .875a4.125 4.125 0 1 1 0 8.25 4.125 4.125 0 0 1 0-8.25"
		})
	]
});
export default SvgRouteFilled;
